<template>
  <div>
    <span style="font-size: 32px; font-weight: bolder">Q&A Values:</span>
  <div class="griddy">
    <div v-for="(val, idx) in data" :key="idx" class="row">
      <div class="question">{{ val.qtext }}</div>
      <div class="answer">{{ val.qans }}</div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: "GridCard",
  props: ["data"]
}
</script>

<style scoped>
.griddy {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.row {
  width: calc(100% - 20px);
  padding: 40px 10px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid lightblue;
}

.row:nth-of-type(2n) {
  background: rgba(211, 211, 211, 0.34);
}

.question {
  width: 45%;
  text-align: right;
}

.answer {
  width: 45%;
  text-align: left;
}
</style>